export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6740.7c22fa5b.jpg";